import qs from "qs";
import { gemmiciApiServiceClient } from "../../../core/apis/gemmiciApiService/AxiosIntance";

export default {
  getSearchPostsAPI(data) {
    let params = {};
    data.username.length ? (params.username = data.username) : 0;
    params.x_min = data.xMin;
    params.x_max = data.xMax;
    params.y_min = data.yMin;
    params.y_max = data.yMax;
    if (!/range|bbox|myPosition/.test(data.placeType)) {
      params.place_type = data.placeType;
      params.long_name = data.longName;
    }
    params.posts_per_page = 20;
    params.page = data.page;
    params.seasons = data.seasons;
    params.theme_names = data.themes;
    params.types = data.media;
    params.exclude_name_ids = data.excludeNameIds;
    return gemmiciApiServiceClient.get("search/posts", {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  },
  getDestinationsAPI(data) {
    let params = {};
    data.username.length ? (params.username = data.username) : 0;
    params.x_min = data.xMin;
    params.x_max = data.xMax;
    params.y_min = data.yMin;
    params.y_max = data.yMax;
    params.coordinates = data.coordinates;
    if (!/range|bbox|myPosition/.test(data.placeType)) {
      params.place_type = data.placeType;
      params.long_name = data.longName;
    }
    params.destinations_per_page = 30;
    params.page = data.page;
    params.seasons = data.seasons;
    params.theme_names = data.themes;
    params.types = data.media;
    return gemmiciApiServiceClient.get("search/destinations", {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  },
  getPostsInDestination(data) {
    let params = {};
    params.posts_per_page = 10;
    params.page = data.page;
    params.seasons = data.seasons;
    params.theme_names = data.themes;
    params.types = data.media;
    params.destination_id = data.destinationId;
    params.exclude_name_ids = data.excludeNameIds;
    data.username.length ? (params.username = data.username) : 0;
    return gemmiciApiServiceClient.get("/search/destination/posts", {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params);
      }
    });
  },
  getGeoInformationsDestinationFromText(text) {
    return gemmiciApiServiceClient.get("search/locations?location=" + text);
  }
};
